import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaQuoteLeft, FaArrowRight } from 'react-icons/fa';

interface FounderInsightProps {
  founderName?: string;
  founderTitle?: string;
  avatarSrc?: string;
  insightText: string;
  linkUrl?: string;
  linkText?: string;
}

const InsightContainer = styled.div`
  background: linear-gradient(135deg, #e9f5ff 0%, #dcebff 100%);
  border-radius: var(--border-radius);
  padding: 2rem;
  margin: 3rem auto;
  max-width: 900px;
  position: relative;
  box-shadow: var(--box-shadow-sm);
  
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

const InsightQuoteIcon = styled.div`
  position: absolute;
  top: -15px;
  left: 30px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
`;

const AvatarWrapper = styled.div`
  flex-shrink: 0;
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
  
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const Avatar = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--white);
  box-shadow: var(--box-shadow-sm);
`;

const InsightContent = styled.div`
  flex: 1;
`;

const InsightText = styled.p`
  font-size: 1.125rem;
  line-height: 1.6;
  color: var(--gray-dark);
  margin-bottom: 1rem;
  font-style: italic;
`;

const FounderInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
`;

const FounderDetails = styled.div`
  flex: 1;
`;

const FounderName = styled.h4`
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
  color: var(--gray-dark);
`;

const FounderTitle = styled.p`
  font-size: 0.875rem;
  color: var(--gray);
  margin: 0.25rem 0 0;
`;

const FounderLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: var(--blue);
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  
  svg {
    margin-left: 0.5rem;
    transition: transform 0.2s ease;
  }
  
  &:hover {
    color: var(--dark-blue);
    
    svg {
      transform: translateX(3px);
    }
  }
`;

const FounderInsight: React.FC<FounderInsightProps> = ({
  founderName = "Miguel Vela",
  founderTitle = "Co-fundador y Director de Desarrollo",
  avatarSrc = "/sobre nosotros/foto-miguel.webp",
  insightText,
  linkUrl = "/sobre-nosotros",
  linkText = "Conócenos mejor"
}) => {
  return (
    <InsightContainer>
      <InsightQuoteIcon>
        <FaQuoteLeft />
      </InsightQuoteIcon>
      
      <AvatarWrapper>
        <Avatar src={avatarSrc} alt={founderName} />
      </AvatarWrapper>
      
      <InsightContent>
        <InsightText>
          {insightText}
        </InsightText>
        
        <FounderInfo>
          <FounderDetails>
            <FounderName>{founderName}</FounderName>
            <FounderTitle>{founderTitle}</FounderTitle>
          </FounderDetails>
          
          <FounderLink to={linkUrl}>
            {linkText} <FaArrowRight />
          </FounderLink>
        </FounderInfo>
      </InsightContent>
    </InsightContainer>
  );
};

export default FounderInsight; 